export default () => {
  const data = {
    event_name: 'click',
    button_name: 'google_play',
    page_section: 'footer',
    name_of_the_page_viewed: 'home_personal',
  };
  return data;
};
